<template>
    <section>
      <div class="columns is-centered">
        <div class="column is-one-third">
          <div class="company-logo">
            <img v-if="this.$store.getters.getInfo.crow !== true" :src="logo" class="logo" />
            <img v-else src="@/assets/CROW-hoofdlogo.png" class="logo"/>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  data() {
    return {
      logo: this.$store.getters.clientStyle.logo,
      fallback_logo: '../../static/img/pd_logo_light.png',
    }
  },
  mounted () {
    let logoCheck = new Image()
    logoCheck.src = this.logo

    setTimeout (() => {
      if (logoCheck.complete) {
        if (logoCheck.width == 0) {
          this.logo = this.fallback_logo
        }
      }
    }, 150)
    
  }
}
</script>

<style scoped>
.company-logo {
  margin-top: 35px;
  margin-bottom: 30px;
  text-align: center;
}

img.logo {
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/intro/Logo.vue